import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';

import datePicker from './locales/en/datePicker.json';
import tooltip from './locales/en/tooltip.json';

export const i18n = createInstance({
  fallbackLng: 'en',
  lng: 'en',
  debug: false,
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      datePicker,
      tooltip,
    },
    ja: {
      datePicker,
      tooltip,
    },
  },
});

i18n.use(initReactI18next).init();
